import {
    Company,
    CompanyBankAccountsGroupedDto,
    CompanyIbanDto,
    CompanyMinDto,
    CorporateRoleFilling,
    UpdateCorporateRoleFillingDto,
} from 'types/companies';
import { portalAPI } from './portalAPI';
import { accumulatedQueryWithFilters } from './util/endpointBuilder';

const APICompaniesSlice = portalAPI.enhanceEndpoints({ addTagTypes: ['Companies', 'CompaniesMin'] }).injectEndpoints({
    endpoints: (builder) => ({
        getCompaniesList: builder.query<CompanyMinDto[], void>({
            query: () => '/v1/companies/min',
            providesTags: ['CompaniesMin'],
        }),
        getCompaniesWithFilters: accumulatedQueryWithFilters<Company>(builder, '/v1/companies', {
            providesTags: ['Companies'],
        }),
        getCompanyById: builder.query<Company, number>({
            query: (entityId) => `/v1/companies/${entityId}`,
            providesTags: (_1, _2, arg) => [{ type: 'Companies', id: arg }],
        }),
        getCorporateRoleFillingList: builder.query<CorporateRoleFilling[], void>({
            query: () => '/v1/companies/corporate-role-fillings',
            keepUnusedDataFor: 0,
        }),
        updateCorporateRoleFillings: builder.mutation<CorporateRoleFilling[], UpdateCorporateRoleFillingDto[]>({
            query: (body) => ({
                url: '/v1/companies/corporate-role-fillings',
                method: 'PUT',
                body,
            }),
        }),
        createCompanyBankAccount: builder.mutation<CompanyIbanDto, { companyId: number; dto: CompanyIbanDto }>({
            query: ({ companyId, dto }) => ({
                url: `/v1/companies/${companyId}/bank-accounts`,
                method: 'POST',
                body: dto,
            }),
            invalidatesTags: ['Companies'],
        }),
        updateCompanyBankAccount: builder.mutation<
            CompanyIbanDto,
            { companyId: number; ibanId: number; dto: CompanyIbanDto }
        >({
            query: ({ companyId, ibanId, dto }) => ({
                url: `/v1/companies/${companyId}/bank-accounts/${ibanId}`,
                method: 'PUT',
                body: dto,
            }),
            invalidatesTags: ['Companies'],
        }),
        getActiveBankAccounts: builder.query<CompanyBankAccountsGroupedDto[], void>({
            query: () => '/v1/companies/active/bank-accounts',
            providesTags: ['Companies'],
        }),
    }),
    overrideExisting: false,
});

export const {
    useGetCompaniesListQuery,
    useGetCompanyByIdQuery,
    useGetCompaniesWithFiltersQuery,
    useLazyGetCompaniesWithFiltersQuery,
    useGetCorporateRoleFillingListQuery,
    useUpdateCorporateRoleFillingsMutation,
    useCreateCompanyBankAccountMutation,
    useUpdateCompanyBankAccountMutation,
    useGetActiveBankAccountsQuery,
} = APICompaniesSlice;
